module.exports = __webpack_public_path__ + "img/tutorial04.684e13f3.svg";